import LogService from "@/services/LogService";

export const actions = {
  listarLogs: ({ commit, getters }) => {
    commit("setOverlay", true);
    LogService.listar(getters.getLogFiltros)
      .then((res) => {
        commit("setLogs", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  }
};

export default {};
